import {
  LOAD_DISCUSSION,
  SEND_MESSAGE,
  DELETE_MESSAGE,
  RECEIVE_MESSAGE,
  LOAD_MORE_MESSAGES,
  CLEAR_DISCUSSION,
  NEW_DOCUMENT,
  APPROVE_DOCUMENT,
  UNAPPROVE_DOCUMENT,
  UPDATE_DELIVERABLE_APPROVED,
  UPDATE_BUDGET,
} from './constants';

export function approveDocument(documentId, approvedData) {
  return {
    type: APPROVE_DOCUMENT,
    documentId,
    approvedData,
  };
}

export function unapproveDocument(documentId, docType) {
  return {
    type: UNAPPROVE_DOCUMENT,
    documentId,
    docType,
  };
}

export function updateDeliverableApproved(data) {
  return {
    type: UPDATE_DELIVERABLE_APPROVED,
    data,
  };
}

export function loadDiscussion(discussionId, receiveMessageCallback) {
  return {
    type: LOAD_DISCUSSION,
    discussionId,
    receiveMessageCallback,
  };
}

export function sendMessage(data) {
  return {
    type: SEND_MESSAGE,
    data,
  };
}

export function deleteMessage(messageId) {
  return {
    type: DELETE_MESSAGE,
    messageId,
  };
}

export function receiveMessage(message) {
  return {
    type: RECEIVE_MESSAGE,
    message,
  };
}

export function updateDocuments(documentData) {
  return {
    type: NEW_DOCUMENT,
    documentData,
  };
}

export function updateBudget(budget, status) {
  return {
    type: UPDATE_BUDGET,
    budget,
    status,
  };
}

export function loadMoreMessages() {
  return {
    type: LOAD_MORE_MESSAGES,
  };
}

export function clearDiscussion() {
  return {
    type: CLEAR_DISCUSSION,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/discussion/actions.js
 **/